<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold">{{$t('small_technical_grants_ev.budget__section_1')}}</h4>
            <h5 class="card-title font-weight-bold">{{$t('small_technical_grants_ev.budget__section_1_sub')}}</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__1_proposal')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.proposal_number"
                                 value="true"
                                 v-model="EvaluationForm.model.proposal_number"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.proposal_number"
                                 value="false"
                                 v-model="EvaluationForm.model.proposal_number"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                        {{$t('small_technical_grants_ev.budget__1_period_implementation')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.period_implementation"
                                 value="true"
                                 v-model="EvaluationForm.model.period_implementation"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.period_implementation"
                                 value="false"
                                 v-model="EvaluationForm.model.period_implementation"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__1_do_categories_follow_sco')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.categories_follow_sco"
                                 value="true"
                                 v-model="EvaluationForm.model.categories_follow_sco"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.categories_follow_sco"
                                 value="false"
                                 v-model="EvaluationForm.model.categories_follow_sco"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__1_does_category_5_follow_real_costs_option')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.category_five_follow_real_costs_option"
                                 value="true"
                                 v-model="EvaluationForm.model.category_five_follow_real_costs_option"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.category_five_follow_real_costs_option"
                                 value="false"
                                 v-model="EvaluationForm.model.category_five_follow_real_costs_option"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__1_does_budget_follow_template')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget_follow_template"
                                 value="true"
                                 v-model="EvaluationForm.model.budget_follow_template"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget_follow_template"
                                 value="false"
                                 v-model="EvaluationForm.model.budget_follow_template"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__1_does_total_amount_match_proposal')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.total_amount_match_proposal"
                                 value="true"
                                 v-model="EvaluationForm.model.total_amount_match_proposal"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.total_amount_match_proposal"
                                 value="false"
                                 v-model="EvaluationForm.model.total_amount_match_proposal"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__1_if_one_category_of_costs_is_proposed')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.if_one_category_of_costs_is_proposed"
                                 value="true"
                                 v-model="EvaluationForm.model.if_one_category_of_costs_is_proposed"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.if_one_category_of_costs_is_proposed"
                                 value="false"
                                 v-model="EvaluationForm.model.if_one_category_of_costs_is_proposed"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__1_if_two_or_more_categories_of_costs_are_proposed')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.if_two_or_more_categories_of_costs_are_proposed"
                                 value="true"
                                 v-model="EvaluationForm.model.if_two_or_more_categories_of_costs_are_proposed"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.if_two_or_more_categories_of_costs_are_proposed"
                                 value="false"
                                 v-model="EvaluationForm.model.if_two_or_more_categories_of_costs_are_proposed"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__1_is_the_duration_of_the_project_in_line_with_proposal')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.is_the_duration_of_the_project_in_line_with_proposal"
                                 value="true"
                                 v-model="EvaluationForm.model.is_the_duration_of_the_project_in_line_with_proposal"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.is_the_duration_of_the_project_in_line_with_proposal"
                                 value="false"
                                 v-model="EvaluationForm.model.is_the_duration_of_the_project_in_line_with_proposal"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('small_technical_grants_ev.budget__comment_missing_doc')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_missing_doc" :comments="EvaluationForm.model.comments_budget_missing_doc"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('small_technical_grants_ev.budget__section_2')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_2_1')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_one"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_one"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_one"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_one"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_2_2')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_two"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_two"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_two"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_two"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_2_3')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_three"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_three"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_three"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_three"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_2_4')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_four"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_four"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_four"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_four"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_2_5')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_five"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_five"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_five"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_five"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_2_6')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_six"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_six"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_six"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_six"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_2_7')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_seven"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_two_seven"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_two_seven"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_two_seven"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('small_technical_grants_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_mathematical" :comments="EvaluationForm.model.comments_budget_mathematical"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('small_technical_grants_ev.budget__section_3')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_3_1')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.costs_aligned"
                                 value="true"
                                 v-model="EvaluationForm.model.costs_aligned"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.costs_aligned"
                                 value="false"
                                 v-model="EvaluationForm.model.costs_aligned"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_3_2')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.clearance_ineligible"
                                 value="true"
                                 v-model="EvaluationForm.model.clearance_ineligible"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.clearance_ineligible"
                                 value="false"
                                 v-model="EvaluationForm.model.clearance_ineligible"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_3_3')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.cost_categories"
                                 value="true"
                                 v-model="EvaluationForm.model.cost_categories"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.cost_categories"
                                 value="false"
                                 v-model="EvaluationForm.model.cost_categories"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_3_4')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.diferent_partners"
                                 value="true"
                                 v-model="EvaluationForm.model.diferent_partners"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.diferent_partners"
                                 value="false"
                                 v-model="EvaluationForm.model.diferent_partners"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_3_5')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.clearly_desc_cost"
                                 value="true"
                                 v-model="EvaluationForm.model.clearly_desc_cost"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.clearly_desc_cost"
                                 value="false"
                                 v-model="EvaluationForm.model.clearly_desc_cost"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>

                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('small_technical_grants_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_eligibility" :comments="EvaluationForm.model.comments_budget_eligibility"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('small_technical_grants_ev.budget__section_4')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_4_1')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_one"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_one"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_one"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_one"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_4_2')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_two"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_two"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_two"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_two"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_4_3')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_three"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_three"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_three"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_three"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_4_4')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_four"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_four"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_four"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_four"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_4_5')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_five"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_five"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_five"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_five"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_4_6')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_six"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_six"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_six"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_six"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_4_7')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_seven"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_seven"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_seven"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_seven"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_4_8')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_eight"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_eight"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_eight"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_eight"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_4_9')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_nine"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_nine"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_nine"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_nine"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_4_10')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_ten"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_four_ten"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_four_ten"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_four_ten"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>

                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('small_technical_grants_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_budget_completness" :comments="EvaluationForm.model.comments_budget_completness"></comment-box>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold mt-4">{{$t('small_technical_grants_ev.budget__section_5')}}</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-9">
            <table class="table-bordered table-full-width">
              <tr>
                <td class="pt-5 pb-5">
                  <div class="row">
                    <div class="col-lg-8"></div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__yes')}}
                        </div>
                        <div class="col-lg-6">
                          {{$t('medium_grant_ev.general__no')}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_5_1')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_five_one"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_five_one"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_five_one"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_five_one"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_5_2')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_five_two"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_five_two"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_five_two"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_five_two"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_5_3')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_five_three"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_five_three"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_five_three"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_five_three"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-lg-8">
                      {{$t('small_technical_grants_ev.budget__section_5_4')}}
                    </div>
                    <div class="col-lg-2 vertical-border">
                      <div class="row">
                        <div class="col-lg-6">
                          <radio name="model.budget__section_five_four"
                                 value="true"
                                 v-model="EvaluationForm.model.budget__section_five_four"
                          >
                          </radio>
                        </div>
                        <div class="col-lg-6">
                          <radio name="model.budget__section_five_four"
                                 value="false"
                                 v-model="EvaluationForm.model.budget__section_five_four"
                          >
                          </radio>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2"></div>
                  </div>

                </td>
              </tr>
            </table>

            <div class="mt-4">
              <h5 class="font-weight-bold">
                {{$t('small_technical_grants_ev.budget__comment_math')}}
              </h5>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_sco" :comments="EvaluationForm.model.comments_sco"></comment-box>
            </div>
          </div>
        </div>


      </div>
      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      ApplicationInfo,
      CommentBox
    },
    data() {
      return {
        EvaluationForm
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
<style lang="scss" scoped>
.pt-5.pb-5 .col-lg-6
{
  white-space: nowrap;
}
</style>
